import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const savedQuery = {
  state: {
    savedQueries: [],
    selectedSavedQuery: {},
    selectedSavedQueryOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    savedQueries(state) {
      return state.savedQueries
    },
    selectedSavedQuery(state) {
      return state.selectedSavedQuery
    },
    selectedSavedQueryOriginal(state) {
      return state.selectedSavedQueryOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    savedQueries(state, payload) {
      state.savedQueries = payload
    },
    selectedSavedQuery(state, payload) {
      state.selectedSavedQuery = JSON.parse(JSON.stringify(payload))
    },
    selectedSavedQueryOriginal(state, payload) {
      state.selectedSavedQueryOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedSavedQuery(context, payload) {
      context.commit('selectedSavedQuery', payload)
    },
    async loadSavedQueries(context, payload) {
      const url = 'SavedQuery'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('savedQueries', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedSavedQuery(context, payload) {
      if (
        context.state.selectedSavedQuery &&
        context.state.selectedSavedQuery.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedSavedQuery',
          context.state.selectedSavedQuery.Id
        )
      }
    },
    async loadSelectedSavedQuery(context, payload) {
      if (
        context.state.selectedSavedQuery &&
        context.state.selectedSavedQuery.Id != payload
      ) {
        context.commit('selectedSavedQuery', {})
      }
      const url = 'SavedQuery/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedSavedQuery', res.data)
        context.commit('selectedSavedQueryOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadSavedQueries(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadSavedQueries')
    },
    async createSavedQuery(context, payload) {
      const url = `SavedQuery`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'saved query created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadSavedQueries')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchSavedQuery(context, payload) {
      var item = context.state.selectedSavedQuery
      if (
        payload.Id &&
        payload.Id == context.state.selectedSavedQueryOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedSavedQueryOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `SavedQuery/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'saved query updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadSavedQueries')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateSavedQuery(context, payload) {
      const url = `SavedQuery/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'saved query updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadSavedQueries')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveSavedQuery(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateSavedQuery', payload)
      } else {
        return context.dispatch('createSavedQuery', payload)
      }
    },
    async deleteSavedQuery(context, payload) {
      const url = `SavedQuery/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'saved query deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadSavedQueries')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default savedQuery
